import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { CommonModule } from '@angular/common';
import { Resolve, ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule } from 'ng2-charts';
import {
    MatAutocompleteModule,
    MatToolbarModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatSidenavModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MAT_DATE_LOCALE,
    MatNativeDateModule,
    MatSortModule,
    MatPaginatorModule,
    MatSliderModule,
    MatRadioModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatFormFieldModule
} from '@angular/material';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MdePopoverModule } from '@material-extended/mde';
import { ScrollingModule } from '@angular/cdk-experimental/scrolling';


// Components
import { ProfileComponent, ImageCropDialogComponent } from './profile/profile.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SearchComponent } from './search/search.component';
import { EditComponent } from './edit/edit.component';
import { PublicProfileComponent } from './public-profile/public-profile.component';
import { FeedComponent } from './feed/feed.component';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { ValidateComponent } from './validate/validate.component';
import { ReportCenterComponent } from './report-center/report-center.component';
import { PowerSearchComponent } from './power-search/power-search.component';
// import {ListFilterPipe} from '../shared/pipes/list-filter.pipe'

// Resolvers
import { AssociateResolver } from './profile/associate.resolver';
import { ManagementResolver } from './profile/management.resolver';

// Services
import { AssociateService } from './shared/services/associate.service';
import { CommonDbService } from './shared/services/common-db.service';
import { AssessmentsService } from './../shared/services/assessments.service';
import { TimelineService } from './shared/services/timeline.service';
import { AuthGuard } from '../shared/services/auth/auth.guard';
import { ReversePipe } from './shared/pipes/reverse.pipe';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


// // internationalization
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { MobileNotificationsComponent } from './mobile-notifications/mobile-notifications.component';
import { MobileActionCenterComponent } from './mobile-action-center/mobile-action-center.component';
import { IonicAngular4CacheModule } from 'ionic-angular4-cache';
import { BackOfficeComponent, AssessmentAddEditDialogComponent, AddPersonToAssessmentComponent } from './back-office/back-office.component';
import { ActionCenterComponent } from './action-center/action-center.component';
import { MobileProfileCardComponent } from './mobile-profile-card/mobile-profile-card.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ManagementChartComponent } from './management-chart/management-chart.component';
import { HrTeamPopUpComponent } from './hr-team-pop-up/hr-team-pop-up.component';
import { PopupComponent } from './report-center/popup/popup.component';
import { PopoverComponent } from './report-center/popover/popover.component';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


const routes: Routes = [
    { path: '', redirectTo: 'home/associate/feed', pathMatch: 'full' },
    { path: 'home/associate', redirectTo: 'home/associate/search', pathMatch: 'full',
     },
    {
        path: 'my-profile',
        component: ProfileComponent,
        data: { page: 'my-profile' },
        resolve: { associate: AssociateResolver, management: ManagementResolver }
    },
    {
        path: 'profile/:action/:id', component: ProfileComponent,
        data: { page: 'profile' },
        resolve: { associate: AssociateResolver, management: ManagementResolver  }
    },
    {
        path: 'profile/:action/:id/:tab', component: ProfileComponent,
        data: { page: 'profile' },
        resolve: { associate: AssociateResolver, management: ManagementResolver  }
    },
    {
        path: 'profile/:action/:id/:tab/:card', component: ProfileComponent,
        data: { page: 'profile' },
        resolve: { associate: AssociateResolver, management: ManagementResolver  }
    },
    {
        path: 'search', component: SearchComponent,
        data: { page: 'search' }
    },
    {
        path: 'feed', component: FeedComponent,
        data: { page: 'feed' }
    },
    {
        path: 'report-center', component: ReportCenterComponent,
        data: { page: 'report-center' }
    },
    {
        path: 'power-search/:searchText', component: PowerSearchComponent, pathMatch: 'full',
        data: { page: 'power-search' }
    },
    {
        path: 'mobile-notifications', component: MobileNotificationsComponent, pathMatch: 'full',
        data: { page: 'power-search' }
    },
    {
        path: 'mobile-actioncenter', component: MobileActionCenterComponent, pathMatch: 'full',
        data: { page: 'power-search' }
    },
    {
        path: 'back-office', component: BackOfficeComponent, pathMatch: 'full'
    },
    {
        path: 'action-center', component: ActionCenterComponent, pathMatch: 'full'
    },
    {
        path: 'mobile-business-card/:id', component: MobileProfileCardComponent, pathMatch: 'full',
        resolve: { associate: AssociateResolver }
    },
    // {
    //     path: 'action-center', component:ActionCenterComponent, pathMatch: 'full',
    // },
    // { path: 'public-profile/:id', component: PublicProfileComponent},
    // { path: 'edit/:id', component: EditComponent},
    // { path: 'validate/:id', component: ValidateComponent}
];

@NgModule({
    imports: [
        MatAutocompleteModule,
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatDatepickerModule,
        MatSortModule,
        MatPaginatorModule,
        MatSliderModule,
        MatSelectModule,
        MatRadioModule,
        NgxMatSelectSearchModule,
        ImageCropperModule,
        ChartsModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        TextMaskModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDMk_knEVp1-lPGaTEO-tc9rTy6fqsVGlk'
          }),
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        SharedModule,
        IonicAngular4CacheModule,
        MdePopoverModule,
        MatSelectModule,
        MatFormFieldModule,
        ScrollingModule,

    ],
    entryComponents: [DeletePopupComponent, ImageCropDialogComponent, AssessmentAddEditDialogComponent, AddPersonToAssessmentComponent,HrTeamPopUpComponent,PopupComponent],
    declarations: [
        ProfileComponent,
        SearchComponent,
        EditComponent,
        AssessmentAddEditDialogComponent,
        AddPersonToAssessmentComponent,
        PublicProfileComponent,
        FeedComponent,
        DeletePopupComponent,
        ValidateComponent,
        ReportCenterComponent,
        ImageCropDialogComponent,
        PowerSearchComponent,
        MobileNotificationsComponent,
        MobileActionCenterComponent,
        BackOfficeComponent,
        ActionCenterComponent,
        MobileProfileCardComponent,
        ManagementChartComponent,
        HrTeamPopUpComponent,
        PopupComponent,
        PopoverComponent,
        ReversePipe,

    ],
    schemas: [NO_ERRORS_SCHEMA],

    providers: [AssociateService, CommonDbService, TimelineService, AssociateResolver, ManagementResolver, AssessmentsService]
})
export class AssociateModule { }
